var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var _useProxy;
import { toQueryString } from "@portal/utils/util-url";
const checkAccessToSendError = (error, include = [], exclude = []) => {
  try {
    if (!include.length && !exclude.length) {
      return true;
    }
    const { message } = error;
    let isValid = !include.length;
    include.forEach((start) => {
      if (message.startsWith(start)) {
        isValid = true;
      }
    });
    exclude.forEach((start) => {
      if (message.startsWith(start)) {
        isValid = false;
      }
    });
    return isValid;
  } catch (error2) {
    return !include.length;
  }
};
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
const DSN_REGEX_WITHOUT_KEY = /^(?:(\w+):)\/\/([\w.-]+)(?::(\d+))?\/(.+)/;
const ERROR_MESSAGE = "Invalid Dsn";
class Dsn {
  constructor(from, useProxy = false) {
    __privateAdd(this, _useProxy, void 0);
    __privateSet(this, _useProxy, useProxy);
    if (typeof from === "string") {
      this._fromString(from);
    } else {
      this._fromComponents(from);
    }
    this._validate();
  }
  toString(withPassword = false) {
    const { host, path, pass, port, projectId, protocol, publicKey } = this;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
  }
  get storeEndpoint() {
    const { host, path, port, projectId, protocol, publicKey } = this;
    const query = toQueryString({
      sentry_key: publicKey,
      sentry_version: "7"
    });
    return `${protocol}://${host}:${port}/${path ? `${path}/` : ""}api/${projectId}/store/${query}`;
  }
  _getDsnParams(match) {
    if (__privateGet(this, _useProxy)) {
      const [protocol2, host2, port2 = "", lastPath2] = match.slice(1);
      return {
        protocol: protocol2,
        host: host2,
        port: port2,
        lastPath: lastPath2,
        publicKey: "",
        pass: ""
      };
    }
    const [protocol, publicKey = "", pass = "", host, port = "", lastPath] = match.slice(1);
    return {
      protocol,
      host,
      port,
      lastPath,
      publicKey,
      pass
    };
  }
  _fromString(str) {
    const match = __privateGet(this, _useProxy) ? DSN_REGEX_WITHOUT_KEY.exec(str) : DSN_REGEX.exec(str);
    if (!match) {
      throw new Error(ERROR_MESSAGE);
    }
    const { protocol, publicKey, pass, host, port, lastPath } = this._getDsnParams(match);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
      path = split.slice(0, -1).join("/");
      projectId = split.pop();
    }
    if (projectId) {
      const projectMatch = projectId.match(/^\d+/);
      if (projectMatch) {
        projectId = projectMatch[0];
      }
    }
    this._fromComponents({
      host,
      pass,
      path,
      projectId,
      port,
      protocol,
      publicKey
    });
  }
  _fromComponents(components) {
    if ("user" in components && !("publicKey" in components)) {
      components.publicKey = components.user;
    }
    this.user = components.publicKey || "";
    this.protocol = components.protocol;
    this.publicKey = components.publicKey || "";
    this.pass = components.pass || "";
    this.host = components.host;
    this.port = components.port || "";
    this.path = components.path || "";
    this.projectId = components.projectId;
  }
  _validate() {
    const keys = ["protocol", "host", "projectId"];
    if (!__privateGet(this, _useProxy)) {
      keys.push("publicKey");
    }
    keys.forEach((component) => {
      if (!this[component]) {
        throw new Error(`${ERROR_MESSAGE}: ${component} missing`);
      }
    });
    if (!this.projectId.match(/^\d+$/)) {
      throw new Error(`${ERROR_MESSAGE}: Invalid projectId ${this.projectId}`);
    }
    if (this.protocol !== "http" && this.protocol !== "https") {
      throw new Error(`${ERROR_MESSAGE}: Invalid protocol ${this.protocol}`);
    }
    if (this.port && isNaN(parseInt(this.port, 10))) {
      throw new Error(`${ERROR_MESSAGE}: Invalid port ${this.port}`);
    }
  }
}
_useProxy = new WeakMap();
const UNKNOWN_FUNCTION = "?";
const chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const reactMinifiedRegexp = /Minified React error #\d+;/i;
function computeStackTrace(ex) {
  let stack = null;
  let popSize = 0;
  if (ex) {
    if (typeof ex.framesToPop === "number") {
      popSize = ex.framesToPop;
    } else if (reactMinifiedRegexp.test(ex.message)) {
      popSize = 1;
    }
  }
  try {
    stack = computeStackTraceFromStacktraceProp(ex);
    if (stack) {
      return popFrames(stack, popSize);
    }
  } catch (e) {
  }
  try {
    stack = computeStackTraceFromStackProp(ex);
    if (stack) {
      return popFrames(stack, popSize);
    }
  } catch (e) {
  }
  return {
    message: extractMessage(ex),
    name: ex && ex.name,
    stack: [],
    failed: true
  };
}
function computeStackTraceFromStackProp(ex) {
  if (!ex || !ex.stack) {
    return null;
  }
  const stack = [];
  const lines = ex.stack.split("\n");
  let isEval;
  let submatch;
  let parts;
  let element;
  for (let i = 0; i < lines.length; ++i) {
    if (parts = chrome.exec(lines[i])) {
      const isNative = parts[2] && parts[2].indexOf("native") === 0;
      isEval = parts[2] && parts[2].indexOf("eval") === 0;
      if (isEval && (submatch = chromeEval.exec(parts[2]))) {
        parts[2] = submatch[1];
        parts[3] = submatch[2];
        parts[4] = submatch[3];
      }
      let url = parts[2] && parts[2].indexOf("address at ") === 0 ? parts[2].substr("address at ".length) : parts[2];
      let func = parts[1] || UNKNOWN_FUNCTION;
      const isSafariExtension = func.indexOf("safari-extension") !== -1;
      const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
      if (isSafariExtension || isSafariWebExtension) {
        func = func.indexOf("@") !== -1 ? func.split("@")[0] : UNKNOWN_FUNCTION;
        url = isSafariExtension ? `safari-extension:${url}` : `safari-web-extension:${url}`;
      }
      element = {
        url,
        func,
        args: isNative ? [parts[2]] : [],
        line: parts[3] ? +parts[3] : null,
        column: parts[4] ? +parts[4] : null
      };
    } else if (parts = winjs.exec(lines[i])) {
      element = {
        url: parts[2],
        func: parts[1] || UNKNOWN_FUNCTION,
        args: [],
        line: +parts[3],
        column: parts[4] ? +parts[4] : null
      };
    } else if (parts = gecko.exec(lines[i])) {
      isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
      if (isEval && (submatch = geckoEval.exec(parts[3]))) {
        parts[1] = parts[1] || `eval`;
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = "";
      } else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
        stack[0].column = ex.columnNumber + 1;
      }
      element = {
        url: parts[3],
        func: parts[1] || UNKNOWN_FUNCTION,
        args: parts[2] ? parts[2].split(",") : [],
        line: parts[4] ? +parts[4] : null,
        column: parts[5] ? +parts[5] : null
      };
    } else {
      continue;
    }
    if (!element.func && element.line) {
      element.func = UNKNOWN_FUNCTION;
    }
    stack.push(element);
  }
  if (!stack.length) {
    return null;
  }
  return {
    message: extractMessage(ex),
    name: ex.name,
    stack
  };
}
function computeStackTraceFromStacktraceProp(ex) {
  if (!ex || !ex.stacktrace) {
    return null;
  }
  const stacktrace = ex.stacktrace;
  const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
  const opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
  const lines = stacktrace.split("\n");
  const stack = [];
  let parts;
  for (let line = 0; line < lines.length; line += 2) {
    let element = null;
    if (parts = opera10Regex.exec(lines[line])) {
      element = {
        url: parts[2],
        func: parts[3],
        args: [],
        line: +parts[1],
        column: null
      };
    } else if (parts = opera11Regex.exec(lines[line])) {
      element = {
        url: parts[6],
        func: parts[3] || parts[4],
        args: parts[5] ? parts[5].split(",") : [],
        line: +parts[1],
        column: +parts[2]
      };
    }
    if (element) {
      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }
      stack.push(element);
    }
  }
  if (!stack.length) {
    return null;
  }
  return {
    message: extractMessage(ex),
    name: ex.name,
    stack
  };
}
function popFrames(stacktrace, popSize) {
  try {
    return __spreadProps(__spreadValues({}, stacktrace), {
      stack: stacktrace.stack.slice(popSize)
    });
  } catch (e) {
    return stacktrace;
  }
}
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return "No error message";
  }
  if (message.error && typeof message.error.message === "string") {
    return message.error.message;
  }
  return message;
}
let endpoint;
function createPayload(entity, message) {
  return {
    timestamp: new Date().toISOString(),
    platform: "javascript",
    message,
    extra: {
      captured: entity instanceof Error ? computeStackTrace(entity) : entity
    }
  };
}
function capture(entity, message = "JtnClientError") {
  if (!endpoint) {
    throw new Error("Cannot capture, initialize client first");
  }
  if (typeof window === "undefined") {
    return;
  }
  fetch(endpoint, {
    method: "POST",
    body: JSON.stringify(createPayload(entity, message)),
    referrer: "origin"
  }).catch(() => console.log("Unable to report the error"));
}
function initSentryClient({
  captureUnhandledErrors = true,
  useProxy = false,
  dsn,
  include = [],
  exclude = []
}) {
  endpoint = new Dsn(dsn, useProxy).storeEndpoint;
  if (typeof window === "undefined") {
    return;
  }
  if (captureUnhandledErrors) {
    const handler = ({ error }) => {
      if (checkAccessToSendError(error, include, exclude)) {
        capture(error);
      }
    };
    window.addEventListener("error", handler);
  }
}
export { capture, checkAccessToSendError, initSentryClient };
